import * as z from 'zod';

export const defaultSchemaHeaders = {
  0: 'Apellido',
  1: 'Segundo Apellido',
  2: 'Correo',
  3: 'Teléfono Celular',
  4: 'CURP',
  5: 'Rol',
  6: 'Sucursal',
};

const phoneRegex = /^[a-zA-Z0-9\s'\-.+()]*$/;
const alphaNumericValidation = /^[a-zA-Z0-9\s-áéíóúÁÉÍÓÚ]+$/;

export const schemaKeys = {
  storeName: 'Nombre de la tienda',
  external_store_id: 'Número de la tienda',
  street: 'Calle',
  ext: 'Número exterior',
  suite: 'Número interior',
  zip: 'Código postal',
  neighborhood: 'Colonia o barrio',
  city: 'Municipio o alcaldía',
  state: 'Estado',
  phone: 'Teléfono de sucursal',
  mall: 'Centro comercial',
  open_mon: 'Apertura lunes',
  open_tue: 'Apertura martes',
  open_wen: 'Apertura miércoles',
  open_thu: 'Apertura jueves',
  open_fri: 'Apertura viernes',
  open_sat: 'Apertura sábado',
  open_sun: 'Apertura domingo',

  close_mon: 'Cierre lunes',
  close_tue: 'Cierre martes',
  close_wen: 'Cierre miércoles',
  close_thu: 'Cierre jueves',
  close_fri: 'Cierre viernes',
  close_sat: 'Cierre sábado',
  close_sun: 'Cierre domingo',

  timezone: 'Zona horaria',
};

export const storeSchema = z.object({
  [schemaKeys.timezone]: z
    .string({
      required_error: 'La zona horaria es obligatoria.',
      invalid_type_error: 'El formato de zona horaria es incorrecto.',
    })
    .trim(),
  [schemaKeys.storeName]: z
    .string({
      required_error: 'El nombre de la tienda es obligatorio.',
      invalid_type_error: 'El nombre de la tienda es invalido.',
    })
    .trim(),
  [schemaKeys.street]: z
    .string({
      required_error: 'La calle es obligatoria.',
      invalid_type_error: 'El formato de calle es incorrecto.',
    })
    .trim()
    .max(128, { message: 'El máximo permitido es de 128 caracteres.' }),
  [schemaKeys.ext]: z.preprocess(
    extNumber => {
      if (typeof extNumber === 'number') {
        return extNumber.toString();
      }

      return extNumber;
    },
    z
      .string({
        required_error: 'El número exterior es obligatorio.',
        invalid_type_error: 'El formato número exterior es incorrecto',
      })
      .min(1, { message: 'El número exterior es obligatorio.' })
      .regex(alphaNumericValidation, {
        message: 'El número exterior no se permite caracteres especiales',
      })
  ),
  [schemaKeys.suite]: z
    .preprocess(
      suiteNumber => {
        if (typeof suiteNumber === 'number') {
          return suiteNumber.toString();
        }

        return suiteNumber;
      },
      z.string({
        required_error: 'El número interior es obligatorio.',
        invalid_type_error: 'El formato número interior es incorrecto',
      })
    )
    .optional(),
  [schemaKeys.zip]: z.preprocess(
    zipNumber => {
      if (typeof zipNumber === 'number') {
        return zipNumber.toString();
      }

      return zipNumber;
    },
    z
      .string({
        required_error: 'El código postal es obligatorio.',
        invalid_type_error: 'El código postal es invalido.',
      })
      .min(5, { message: 'El código postal debe ser  es obligatorio.' })
      .regex(/^\d{5}$/, 'El código postal debe ser de 5 dígitos')
  ),
  [schemaKeys.neighborhood]: z
    .string({
      required_error: 'El barrio o colonia es obligatorio.',
      invalid_type_error: 'El barrio o colonia es invalido.',
    })
    .trim(),
  [schemaKeys.city]: z
    .string({
      required_error: 'El Municipio o alcaldía es obligatorio.',
      invalid_type_error: 'El Municipio o alcaldía es invalido',
    })
    .trim(),
  [schemaKeys.state]: z
    .string({
      required_error: 'El estado es obligatorio.',
      invalid_type_error: 'El estado es invalido.',
    })
    .trim(),
  [schemaKeys.phone]: z.preprocess(
    phoneNumber => {
      if (typeof phoneNumber === 'number') {
        return phoneNumber.toString();
      }

      return phoneNumber;
    },
    z
      .string({
        required_error: 'El teléfono es requerido',
        invalid_type_error: 'El formato del teléfono es incorrecto',
      })
      .regex(phoneRegex, { message: 'El teléfono no es válido' })
      .max(10, { message: 'El teléfono debe ser 10 dígitos exactos' })
      .optional()
  ),
  [schemaKeys.open_mon]: z.date().nullable(),
  [schemaKeys.close_mon]: z.date().nullable(),

  [schemaKeys.open_tue]: z.date().nullable(),
  [schemaKeys.close_tue]: z.date().nullable(),

  [schemaKeys.open_wen]: z.date().nullable(),
  [schemaKeys.close_wen]: z.date().nullable(),

  [schemaKeys.open_thu]: z.date().nullable(),
  [schemaKeys.close_thu]: z.date().nullable(),

  [schemaKeys.open_fri]: z.date().nullable(),
  [schemaKeys.close_fri]: z.date().nullable(),

  [schemaKeys.open_sat]: z.date().nullable(),
  [schemaKeys.close_sat]: z.date().nullable(),

  [schemaKeys.open_sun]: z.date().nullable(),
  [schemaKeys.close_sun]: z.date().nullable(),
});
